import React from 'react'
import PropTypes from 'prop-types'
import OriginSelectionSearch from '~/components/common/SelectionSearch'

const SelectionSearch = ({
  form,
  field,
  clearable,
  multiple,
  actionOnFocus,
  onApply,
  disabled,
  ...props
}) => (
  <OriginSelectionSearch
    name={field.name}
    value={field.value}
    {...field}
    multiple={multiple}
    onSelected={(newValue, action) => {
      if (multiple) {
        if (!action && newValue) {
          form.setFieldValue(field.name, newValue || [])
        }
        if (action === 'apply') {
          form.setFieldValue(`backup_${field.name}`, undefined)
          onApply(field.value)
        }
      } else {
        form.setFieldValue(field.name, newValue)
      }
    }}
    onClear={
      clearable
        ? () => form.setFieldValue(field.name, multiple ? [] : '')
        : null
    }
    {...props}
    {...(multiple
      ? {
          actionOnFocus: () => {
            form.setFieldValue(`backup_${field.name}`, field.value || [])
          },
          actionOnBlur: () => {
            form.setFieldValue(
              field.name,
              form.values[`backup_${field.name}`] || [],
            )
            form.setFieldValue(`backup_${field.name}`, undefined)
          },
        }
      : { actionOnFocus })}
    disabled={disabled || !!form.values.__readOnly}
  />
)

SelectionSearch.defaultProps = {
  clearable: false,
  multiple: false,
  actionOnFocus: null,
  onApply: null,
  disabled: false,
}

SelectionSearch.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  clearable: PropTypes.bool,
  multiple: PropTypes.bool,
  actionOnFocus: PropTypes.func,
  onApply: PropTypes.func,
  disabled: PropTypes.bool,
}

export default SelectionSearch
